import { motion } from 'framer-motion';
import type { Stage } from '../data/lifecycle';

interface Props {
  stage: Stage;
  index: number;
}

export default function LifecyclePanel({ stage, index }: Props) {
  return (
    <motion.section
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-100px' }}
      transition={{ duration: 0.4 }}
      className="grid md:grid-cols-[120px_1fr] gap-8 rounded-2xl border hairline bg-surface/60 p-7"
    >
      <div>
        <div className="font-mono text-xs text-ink-mute mb-1">STAGE</div>
        <div className="font-display text-5xl tracking-tight2 text-accent">
          {String(index + 1).padStart(2, '0')}
        </div>
      </div>
      <div>
        <h3 className="font-display text-2xl md:text-3xl tracking-tight2 mb-4">
          {stage.name}
        </h3>
        <div className="grid md:grid-cols-2 gap-6 text-[15px] leading-relaxed mb-5">
          <div>
            <div className="font-mono text-[11px] text-accent-warm mb-1">PRE-2022</div>
            <p className="text-ink-dim">{stage.before}</p>
          </div>
          <div>
            <div className="font-mono text-[11px] text-accent mb-1">MAY 2026</div>
            <p className="text-ink-dim">{stage.after}</p>
          </div>
        </div>
        <div className="grid md:grid-cols-3 gap-4 text-sm">
          <Tag label="Paradigm shift" value={stage.shift} />
          <Tag label="Benefit" value={stage.benefit} tone="good" />
          <Tag label="Risk" value={stage.risk} tone="risk" />
        </div>
      </div>
    </motion.section>
  );
}

interface TagProps {
  label: string;
  value: string;
  tone?: 'good' | 'risk';
}

function Tag({ label, value, tone }: TagProps) {
  const color =
    tone === 'good' ? 'text-good' : tone === 'risk' ? 'text-risk' : 'text-ink';
  return (
    <div className="rounded-lg border hairline p-3 bg-bg/40">
      <div className={`font-mono text-[10px] ${color} mb-1`}>
        {label.toUpperCase()}
      </div>
      <p className="text-ink-dim leading-relaxed">{value}</p>
    </div>
  );
}
